import Vue from 'vue';
import Vuex from 'vuex';

//modules import
import user from './modules/User';
import documentGroup from './modules/DocumentGroup';
import documentRule from './modules/DocumentRule';
import employee from './modules/Employee';
import employeeType from './modules/EmployeeType';
import client from './modules/Client';
import clientType from './modules/ClientType';
import cognitoUser from './modules/CognitoUser';
import groupType from './modules/GroupType';
import documentFile from './modules/DocumentFile';
import authorizationRule from './modules/AuthorizationRule';
import authorizationRecord from './modules/AuthorizationRecord';
import approval from './modules/Approval';
import report from './modules/Report';
import assignment from './modules/Assignment';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    documentGroup,
    documentRule,
    employee,
    client,
    clientType,
    employeeType,
    groupType,
    cognitoUser,
    documentFile,
    authorizationRule,
    authorizationRecord,
    report,
    assignment,
    approval
  }
})
